/* eslint-disable */
import React from 'react';
import PageSingleColumn from '../Layouts/PageSingleColumn';
import LayoutTemplate1PagePropTypes from './LayoutTemplate1.page.props';

/**
 * LayoutTemplate1PageComponent
 * @export
 * @class LayoutTemplate1PageComponent
 * @extends {React.Component<LayoutTemplate1PageComponentComposedProps, LayoutTemplate1PageComponentState>}
 */
export class LayoutTemplate1PageComponent extends React.Component {
  /**
   * The `props` to seed when any specific prop receives an `undefined` value. **NOT** a `null` value
   * @static
   * @type {Partial<LayoutTemplate1PageComponentProps>}
   * @memberof LayoutTemplate1PageComponent
   */
  static defaultProps = {};

  /**
   * The name of the Component to display when debugging
   * @static
   * @type {`LayoutTemplate1Page`}
   * @memberof LayoutTemplate1PageComponent
   */
  static displayName = `LayoutTemplate1Page`;

  /**
   * The values to use to apply runtime typechecking on the props
   * @static
   * @type {object}
   * @memberof LayoutTemplate1PageComponent
   */
  static propTypes = LayoutTemplate1PagePropTypes;

  /**
   * Data specific to the `<LayoutTemplate1Page />` instance
   * @type {LayoutTemplate1PageComponentState}
   * @memberof LayoutTemplate1PageComponent
   */
  state = {};

  /**
   * Render the layoutTemplate1
   * @returns {React.Component} The rendered layoutTemplate1
   * @memberof LayoutTemplate1PageComponent
   */
  exampleComponent = () => (
    <div style={{ backgroundColor: `#ffb9ec`, height: `2000px` }}>
      Any component can go in this space e.g. 4 columns dashboard with cards, or single column T&amp;C's. For now its just tall box with lots of pink.
    </div>
  );

  /**
   * Render the component
   * @returns {React.Component} The rendered `<LayoutTemplate1Page />`
   * @memberof LayoutTemplate1PageComponent
   */
  render() {
    return (
      <PageSingleColumn defaultLanguageHeading="LayoutTemplate1" title="LayoutTemplate1Page.PageTitle">
        {this.exampleComponent()}
      </PageSingleColumn>
    );
  }
}

export default LayoutTemplate1PageComponent;
